import { cn } from '@/lib/utils'

export function Spinner({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('size-4 animate-spin text-current', className)}
      aria-hidden
    >
      <circle
        cx="12" cy="12" r="10" fill="none"
        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
        strokeDasharray="40 60" strokeDashoffset="0"
      />
    </svg>
  )
}
